<smallstack-icon
  name="question-mark"
  [size]="size"
  [matTooltip]="helpText | translate"
  [ngStyle]="{ 'padding-bottom': size + 'px' }"
  style="cursor: help"
></smallstack-icon>
